import { HIGH_SCORE_KEY } from "./constants";

export function getHighScore(): number {
    try {
        const val = localStorage.getItem(HIGH_SCORE_KEY);
        if (!val) return 0;
        const parsed = parseInt(val, 10);
        return isNaN(parsed) ? 0 : parsed;
    } catch {
        return 0;
    }
}

/** Saves the score only if it beats the stored best. Returns true when it does. */
export function saveIfHighScore(score: number): boolean {
    try {
        if (score > getHighScore()) {
            localStorage.setItem(HIGH_SCORE_KEY, score.toString());
            return true;
        }
    } catch {
        // Ignore storage errors in sandboxed environments
    }
    return false;
}
